module.exports = __webpack_public_path__ + "img/Emily-01.d8bdc656.svg";